var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40019 5.40004C6.89136 5.40004 8.10019 4.1912 8.10019 2.70002C8.10019 1.20884 6.89136 0 5.40019 0C3.90903 0 2.7002 1.20884 2.7002 2.70002C2.7002 4.1912 3.90903 5.40004 5.40019 5.40004Z",
    fill: "#B250FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.325C0 11.6978 0.34538 12 0.771427 12C1.19747 12 1.41265 12 2.14233 12C3.63549 12 7.87181 12 9.04505 12C9.78999 12 9.6025 12 10.0285 12C10.4546 12 10.8 11.6978 10.8 11.325C10.8 8.71544 8.38232 6.59998 5.39999 6.59998C2.41766 6.59998 0 8.71544 0 11.325Z",
    fill: "#B250FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d39e79a0ef1794b621b40c4eb5fbf40f.svg";
export { ForwardRef as ReactComponent };